import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function RouteErrorPage() {
  const navigate = useNavigate();
  const error = useRouteError();

  let title = 'Something went wrong';
  let message = 'An unexpected error occurred.';

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = 'Page not found';
      message = 'The page you are looking for does not exist.';
    }
    if (error.status === 401) {
      title = 'Unauthorized';
      message = 'You are not authorized to view this page.';
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '100vh',
          textAlign: 'left',
        }}
      >
        <div style={{ flexBasis: '35%', margin: '100px' }}>
          <strong>Oops! This link is no longer valid</strong>
          <p>The page you’re trying to access doesn’t exist or is no longer available.</p>
          <div>
            <p>Please check the URL or return to the homepage.</p>
            <Button variant="outlined" onClick={() => navigate('/')}>
              Return to Home
            </Button>
          </div>
        </div>
        <img
          style={{ flexBasis: '40%', flexGrow: 0, margin: '25px' }}
          src={`${process.env.PUBLIC_URL}/404.svg`}
          alt="404"
        />
      </div>
    </>
  );
}
